<template>
  <Grid gtc="repeat(5, 80px)" justify-items="start" class="recommendations-editor q-ml-md">
    <SpecialBtn
      v-for="status of statuses"
      :key="status.id"
      :active="params.value === status.name"
      :type="calculatedStatus(status)"
      :disable="params.disable"
      @click="valueChanged(status.name)"
    >
      {{ status.name }}
    </SpecialBtn>
  </Grid>
</template>

<script>
// Components
import SpecialBtn from '@/ui/SpecialBtn'

export default {
  components: {
    SpecialBtn
  },

  computed: {
    statuses() {
      const vuexModule = this.params.vuexModule
      const vuexState = this.params.vuexState

      return this.$store.state[vuexModule][vuexState]
    },

    calculatedStatus() {
      return status => {
        if (this.params.vuexModule === 'recommendations') {
          return status.name.replace('to cancel', 'for cancel')
        }

        return status.name.replace('to accept', 'to renew')
      }
    }
  },

  methods: {
    valueChanged(newVal) {
      this.params.setValue(newVal)
    }
  }
}
</script>
